export const hasConfiguredModelProvider = (config) => Boolean(config.default_provider && config.default_model_id);
